import React, { useState } from "react";
import {
  BaseEdge,
  EdgeLabelRenderer,
  getSmoothStepPath,
  useReactFlow,
  type EdgeProps,
} from "@xyflow/react";

export default function ButtonEdge({
  id,
  sourceX,
  sourceY,
  targetX,
  targetY,
  sourcePosition,
  targetPosition,
  style = {},
  markerEnd,
  data,
}: EdgeProps) {
  const { setEdges } = useReactFlow();

  // Calcular o caminho da edge usando uma curva Bezier
  const [edgePath, labelX, labelY] = getSmoothStepPath({
    sourceX,
    sourceY,
    sourcePosition,
    targetX,
    targetY,
    targetPosition,
  });

  const [icone, setIcone] = useState("sec-aberto.png");
  const [label, setLabel] = useState("");
  const [isEditing, setIsEditing] = useState(false);
  const [inputValue, setInputValue] = useState(label);

  const saveLabel = () => {
    setLabel(inputValue);
    setIsEditing(false);

    // Atualizar o estado da edge com o novo label
    setEdges((edges) =>
      edges.map((edge) =>
        edge.id === id
          ? { ...edge, data: { ...edge.data, label: inputValue } }
          : edge
      )
    );
  };

  // Função para lidar com o evento de Enter no campo de input
  const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === "Enter") {
      saveLabel();
      setIcone("fechado.png");
    }
  };

  return (
    <>
      {/* Desenhar a edge base */}
      <BaseEdge path={edgePath} markerEnd={markerEnd} style={style} />

      {/* Animação ao longo da linha */}
      <circle r="6" fill="#ff0073">
        <animateMotion
          dur="2s"
          repeatCount="indefinite"
          keyPoints={icone === "fechado.png" ? "0;1" : "0;0.5"}
          keyTimes="0;1"
          path={edgePath}
        />
      </circle>

      {/* Botão da imagem centralizado na linha */}
      <EdgeLabelRenderer>
        <div
          style={{
            position: "absolute",
            transform: `translate(-50%, -50%) translate(${labelX}px,${labelY}px)`,
            pointerEvents: "all",
          }}
          className="nodrag nopan"
          onClick={() => setIsEditing(true)}
        >
          <button className="edgebutton">
            <img src={require(`../assets/${icone}`)} alt="Ícone" />
          </button>
        </div>
      </EdgeLabelRenderer>

      {/* Label separado abaixo da linha */}
      <EdgeLabelRenderer>
        <div
          style={{
            position: "absolute",
            transform: `translate(-50%, -50%) translate(${labelX}px,${
              labelY + 20
            }px)`,
            fontSize: 12,
            pointerEvents: "none",
            textAlign: "center",
          }}
          className="nodrag nopan"
          onClick={() => setIsEditing(true)}
        >
          {isEditing ? (
            <input
              type="text"
              value={inputValue}
              onChange={(e) => setInputValue(e.target.value)}
              onKeyDown={handleKeyDown}
              onBlur={saveLabel}
              autoFocus
              style={{ fontSize: 12, padding: 4, border: "1px solid #ccc" }}
            />
          ) : (
            <>{label && <span>{label}</span>}</>
          )}
        </div>
      </EdgeLabelRenderer>
    </>
  );
}
